import NiceModal from '@ebay/nice-modal-react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Breadcrumbs,
  Button,
  Grid,
  Paper,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { AbandonProfileModal } from './modals/AbandonProfileModal'

export default function SubHeaderProfile({
  title,
  subtitle,
  isDirty
}: {
  title: string
  subtitle: string
  isDirty: boolean
}) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Box sx={{ width: '100%' }}>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: 'background.default',
          height: '4.5rem',
          width: '100%'
        }}
      >
        <Grid
          container
          maxWidth='xl'
          sx={{
            margin: '0 auto',
            height: '100%',
            px: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Grid>
            <Breadcrumbs
              separator='/'
              sx={{ fontSize: '0.875rem', color: '#FFF' }}
            >
              <Typography variant='body1' color='#FFF'>
                {title}
              </Typography>

              <Box display='flex' alignItems='center' gap='0.25rem'>
                <Typography variant='body1' color='#FFF' fontWeight='bold'>
                  {subtitle}
                </Typography>
              </Box>
            </Breadcrumbs>
          </Grid>

          <Grid>
            <Button
              variant='text'
              startIcon={<CloseIcon />}
              onClick={() => {
                if (isDirty) {
                  NiceModal.show(AbandonProfileModal)
                } else {
                  navigate(-1)
                }
              }}
              sx={{ color: '#FFF', textTransform: 'none' }}
            >
              {t('common.exit')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}
